import { ArrowLeftOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./styles.module.scss";

export interface CoreModalProps {
  title?: string;
  open: boolean;
  children?: ReactNode;
  onCancel: () => void;
  onSave?: () => void;
  disabledButton?: boolean;
  backButton?: () => void;
  width?: number;
  maskClosable?: boolean;
}

const CoreModal: React.FC<CoreModalProps> = ({
  title,
  children,
  open,
  onCancel,
  onSave,
  disabledButton,
  backButton,
  width = 740,
  maskClosable = true,
}) => {
  return (
    <Modal
      width={width}
      open={open}
      onCancel={onCancel}
      footer={null}
      className={styles.modal}
      centered
      destroyOnClose
      maskClosable={maskClosable}
    >
      <div className={styles.modalContainer}>
        <div className={styles.head}>
          {backButton && (
            <ArrowLeftOutlined
              onClick={backButton}
              className={styles.arrowBack}
            />
          )}
          <div className={styles.title}>{title}</div>
        </div>
        {children}
        <div className={styles.bottomActions}>
          <button
            onClick={onCancel}
            className={classNames(styles.button, styles.cancel)}
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            disabled={disabledButton}
            className={classNames(styles.button, styles.save, {
              [styles.disabled]: disabledButton,
            })}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CoreModal;
